<p>edit-config-history works!</p>
